var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1860_12389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49935 2.66675C8.86754 2.66675 9.16602 2.96522 9.16602 3.33341V7.33341H13.166C13.5342 7.33341 13.8327 7.63189 13.8327 8.00008C13.8327 8.36827 13.5342 8.66675 13.166 8.66675H9.16602V12.6667C9.16602 13.0349 8.86754 13.3334 8.49935 13.3334C8.13116 13.3334 7.83268 13.0349 7.83268 12.6667V8.66675H3.83268C3.46449 8.66675 3.16602 8.36827 3.16602 8.00008C3.16602 7.63189 3.46449 7.33341 3.83268 7.33341H7.83268V3.33341C7.83268 2.96522 8.13116 2.66675 8.49935 2.66675Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1860_12389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H16.5V16H0.5V0Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPlus);
export default __webpack_public_path__ + "static/media/selectPlus.9f88fbb1.svg";
export { ForwardRef as ReactComponent };